var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.15 18.375L11.6375 12.8625C11.2 13.2125 10.6969 13.4896 10.1281 13.6937C9.55938 13.8979 8.95417 14 8.3125 14C6.72292 14 5.37775 13.4493 4.277 12.348C3.17625 11.2467 2.62558 9.9015 2.625 8.3125C2.62442 6.7235 3.17508 5.37833 4.277 4.277C5.37892 3.17567 6.72408 2.625 8.3125 2.625C9.90092 2.625 11.2464 3.17567 12.3489 4.277C13.4514 5.37833 14.0018 6.7235 14 8.3125C14 8.95417 13.8979 9.55937 13.6938 10.1281C13.4896 10.6969 13.2125 11.2 12.8625 11.6375L18.375 17.15L17.15 18.375ZM8.3125 12.25C9.40625 12.25 10.3361 11.8673 11.102 11.102C11.8679 10.3367 12.2506 9.40683 12.25 8.3125C12.2494 7.21817 11.8668 6.28863 11.102 5.52388C10.3373 4.75913 9.40742 4.37617 8.3125 4.375C7.21758 4.37383 6.28804 4.75679 5.52388 5.52388C4.75971 6.29096 4.37675 7.2205 4.375 8.3125C4.37325 9.4045 4.75621 10.3343 5.52388 11.102C6.29154 11.8697 7.22108 12.2523 8.3125 12.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.792efe0d03729d58437bb94030ee8482.svg";
export { ForwardRef as ReactComponent };